import React from 'react';
import { Link } from 'react-router-dom';
import ProtectedEmail from './ProtectedEmail';
import logo192 from '../assets/images/logo192.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
              <img 
                src={logo192} 
                alt="Đức Phát Đạt Logo" 
                style={{ 
                  height: '50px', 
                  width: 'auto', 
                  marginRight: '15px',
                  verticalAlign: 'middle'
                }} 
              />
              <h3 style={{ margin: 0 }}>Đức Phát Đạt</h3>
            </div>
            <p>
              Công ty TNHH Thương mại Dịch Vụ Đức Phát Đạt - Chuyên phân phối gỗ nguyên liệu hàng đầu tại Việt Nam với hơn 15 năm kinh nghiệm.
            </p>
            <p>
              <strong>Tôn chỉ:</strong> Đặt chữ "TÍN" lên hàng đầu trong mọi hoạt động kinh doanh.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>Liên kết nhanh</h3>
            <Link to="/">Trang chủ</Link>
            <Link to="/about">Về Đức Phát Đạt</Link>
            <Link to="/services">Dịch vụ</Link>
            <Link to="/news">Tin tức</Link>
            <Link to="/contact">Liên hệ</Link>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3>Dịch vụ chính</h3>
            <p>🪵 Bán gỗ tròn, gỗ xây dựng</p>
            <p>🔨 Cưa xẻ gỗ gia công</p>
            <p>🚛 Dịch vụ xe cẩu</p>
            <p>📦 Vận chuyển gỗ</p>
            <p>💼 Tư vấn chuyên nghiệp</p>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3>Thông tin liên hệ</h3>
            <p>
              <strong>📍 Địa chỉ:</strong><br />
              Số 2 Hoàng Hữu Nam<br />
              Phường Long Bình, TP HCM
            </p>
            <p>
              <strong>📞 Điện thoại:</strong><br />
              <a href="tel:0915444447" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>
                0915 444 447
              </a> (anh Kiên)<br />
              <a href="tel:0906838171" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>
                0906 838 171
              </a> (cô Nhung)
            </p>
            <p>
              <strong>📧 Email:</strong><br />
              <ProtectedEmail 
                email="ducphatdatco@gmail.com"
                style={{ color: 'rgba(255, 255, 255, 0.8)' }}
              />
            </p>
            <p>
              <strong>🗺️ Bản đồ:</strong><br />
              <a 
                href="https://goo.gl/maps/v3FYpZXcdGvYEdc39?g_st=az" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}
              >
                Xem trên Google Maps
              </a>
            </p>
          </div>
        </div>

        {/* Products */}
        <div style={{ 
          borderTop: '1px solid rgba(255, 255, 255, 0.1)', 
          paddingTop: '2rem', 
          marginTop: '2rem' 
        }}>
          <div className="footer-section">
            <h3>Sản phẩm chính</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
              <div>
                <p><strong>Gỗ thông Coffa</strong></p>
                <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.6)' }}>
                  Xuất xứ: Mỹ, Canada, Châu Âu
                </p>
              </div>
              <div>
                <p><strong>Gỗ thông sấy</strong></p>
                <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.6)' }}>
                  Đã qua xử lý sấy khô
                </p>
              </div>
              <div>
                <p><strong>Gỗ tròn nhập khẩu</strong></p>
                <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.6)' }}>
                  Đa dạng kích thước
                </p>
              </div>
              <div>
                <p><strong>Gỗ xây dựng</strong></p>
                <p style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.6)' }}>
                  Chất lượng cao
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Business Hours */}
        <div style={{ 
          borderTop: '1px solid rgba(255, 255, 255, 0.1)', 
          paddingTop: '2rem', 
          marginTop: '2rem' 
        }}>
          <div className="footer-section">
            <h3>Giờ làm việc</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem' }}>
              <div>
                <p><strong>Thứ 2 - Thứ 6</strong></p>
                <p>8:00 - 17:00</p>
              </div>
              <div>
                <p><strong>Thứ 7</strong></p>
                <p>8:00 - 12:00</p>
              </div>
              <div>
                <p><strong>Chủ nhật</strong></p>
                <p>Nghỉ</p>
              </div>
            </div>
            <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.6)' }}>
              <em>Hỗ trợ ngoài giờ cho trường hợp khẩn cấp</em>
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
            <div>
              <p>&copy; 2024 Công ty TNHH Thương mại Dịch Vụ Đức Phát Đạt. Tất cả quyền được bảo lưu.</p>
              <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>
                Thành lập năm 2009 | Kinh nghiệm 15+ năm trong ngành gỗ
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ fontSize: '0.9rem' }}>
                <strong>Cam kết chất lượng:</strong><br />
                Gỗ khai thác hợp pháp<br />
                Bảo vệ môi trường<br />
                Phát triển bền vững
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
